import axios from 'axios'

let log = {}
log.find = params => {
  return axios.get('/admin/find', {params})
}
log.load = params => {
  return axios.get('/admin/load', {params})
}
export default log



// WEBPACK FOOTER //
// ./src/api/log.js